module["exports"] = [
  "Apt. ###",
  "# étage"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/secondary_address.js
// module id = 1665
// module chunks = 0